module.exports = __webpack_public_path__ + "static/media/Stock 1.8b489399.svg";